import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ReAuthIntegrationModal from 'components/Modal/ReAuthIntegrationModal';
import Scheduler from '../SchedulerEditor';
import { ZapierIntegration } from './Zapier';
import EmailIntegration from './EmailIntegration';
import CalendarIntegration from './CalendarIntegration';

import './integrations.scss';

const Integrations = () => {
  const location = useLocation();
  const userInfo = useSelector(state => state.global.userInfo);
  const { personas, integrations, integrationsEnabled } = userInfo || {};
  const { isOrgOwner, isOrgMember } = personas || {};
  const expiredIntegration = integrations?.find(integration => integration?.grantStatus === 'expired');

  if (location.pathname.includes('/scheduler-editor')) {
    return (<Scheduler />);
  }

  return (
    <>
      <div className="integration-list">
        {(integrationsEnabled && (isOrgOwner || isOrgMember)) && (
          <>
            <CalendarIntegration />
            <EmailIntegration />
          </>
        )}
        <ZapierIntegration />
      </div>
      <ReAuthIntegrationModal expiredIntegration={expiredIntegration} />
    </>

  );
};

export default Integrations;
